/* eslint-disable react/display-name */

import './style.scss';

import React, { Fragment } from 'react';
import classnames from 'classnames';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import ProductImage from 'components/ui/productImage';
import QtyDiscount from 'components/product/qtyDiscount';
import View from 'components/ui/view';
import Text from 'components/ui/text';

function LazyWrapper({ lazyLoad, children }) {
  return lazyLoad ? (
    <LazyLoad once={true} height={200} offset={150}>
      {children}
    </LazyLoad>
  ) : (
    children
  );
}

function LinkWrapper({ linkProps, children }) {
  return linkProps ? <Link {...linkProps}>{children}</Link> : children;
}

function BaseProductItem({
  product,
  includeItemProps,
  lazyLoad,
  linkProps,
  renderOnHover
}) {
  return (
    <Fragment>
      <LinkWrapper linkProps={linkProps}>
        <div
          className={classnames('prod-item', {
            'prod-item--sold-out': product.soldout
          })}
        >
          <LazyWrapper lazyLoad={lazyLoad}>
            <ProductImage
              product={product}
              alt={product.title}
              itemProp={includeItemProps ? 'image' : undefined}
              className="prod-item__img"
            />
          </LazyWrapper>
          <View
            padding="xs"
            className="text-overflow prod-item__descr text-left"
          >
            <Text
              weight="bold"
              otherProps={{ itemProp: includeItemProps ? 'name' : undefined }}
            >
              <View
                inlineBlock
                className={classnames('text-overflow', 'prod-item__title', {
                  'prod-item__title--sold-out': product.soldout
                })}
              >
                {product.title}
              </View>
              {product.soldout && (
                <Fragment>
                  {' '}
                  <View inlineBlock className={'prod-item__sold-out'}>
                    |{' '}
                    <Text error weight="bold" tag="span">
                      Sold Out
                    </Text>
                  </View>
                </Fragment>
              )}
            </Text>
            <div
              className="text-overflow"
              itemProp={includeItemProps ? 'description' : undefined}
            >
              {product.subtitle}
            </div>
            <div className="text-overflow">
              {product.volume}
              {!!product.price && (
                <Fragment>
                  {' '}
                  |{' '}
                  {!!product.regularPriceDisplay &&
                    product.regularPriceDisplay !== product.priceDisplay && (
                      <span className="text-light strikethrough">
                        ${product.regularPriceDisplay}
                      </span>
                    )}
                  ${product.priceDisplay}
                </Fragment>
              )}
            </div>

            {!!product.price &&
              (product.free_shipping || product.package_qty) && (
                <QtyDiscount
                  product={product}
                  textProps={{
                    weight: 'med',
                    success: true
                  }}
                  renderIcon={null}
                  className={null}
                  text={product.free_shipping ? 'Free Shipping' : null}
                />
              )}
          </View>

          {renderOnHover && (
            <div className="prod-item__on-hover">{renderOnHover()}</div>
          )}
        </div>
      </LinkWrapper>
    </Fragment>
  );
}

export default BaseProductItem;
